var set = require('regenerate')();

set.addRange(0x2C00, 0x2C2E).addRange(0x2C30, 0x2C5E).addRange(0x1E000, 0x1E006).addRange(0x1E008, 0x1E018).addRange(0x1E01B, 0x1E021).addRange(0x1E023, 0x1E024).addRange(0x1E026, 0x1E02A);
module.exports = set;